import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../../Frozenwala.png";
import Navber from "./Navbar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { IoTrashOutline, IoEyeOutline } from "react-icons/io5";
import { useWishlist } from "../../contexts/WishlistContext";

const WishlistPage = () => {
  const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const moduleStyles = (
    <style>{`
      .wishlist-page-container {
        margin-top: 100px !important; /* Balanced distance because the navbar is now flat at the top */
        min-height: 75vh;
        max-width: 1400px !important;
        width: 100%;
      }
      .wishlist-header-row {
        margin-bottom: 24px;
      }
      .wishlist-header-wrapper {
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        padding-left: 4px; 
      }
      .wishlist-back-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid #e0e0e0;
        border-radius: 50px;
        padding: 8px 18px;
        font-size: 14px;
        font-weight: 600;
        color: #444;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 6px rgba(0,0,0,0.04);
      }
      .wishlist-back-btn:hover {
        background: #f8f9fa;
        border-color: #ccc;
        transform: translateX(-2px);
      }
      .wishlist-title {
        font-weight: 700 !important;
        font-size: 28px;
        color: #212529;
        margin: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .premium-card-wrapper {
        border-radius: 20px !important;
        padding: 12px !important;
        background: #ffffff !important;
        border: 1px solid rgba(0, 0, 0, 0.03) !important;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
        transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      .premium-card-wrapper:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
      }
      .symmetric-image-frame {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        border-radius: 14px !important;
        background-color: #f7f7f7;
      }
      .symmetric-cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover !important;
        transition: transform 0.3s ease;
      }
      .premium-card-wrapper:hover .symmetric-cover-img {
        transform: scale(1.04);
      }
      .wishlist-action-container {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin-top: auto;
      }
      .btn-orange-pill {
        background-color: #5dc5fa !important;
        color: #ffffff !important;
        border: none !important;
        font-weight: 700;
        border-radius: 50px !important;
        padding: 8px 16px;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        flex-grow: 1;
        transition: background-color 0.2s ease;
      }
      .btn-orange-pill:hover {
        background-color: #5dc5fa !important;
      }
      .btn-remove-circle {
        background: #fff5f5 !important;
        border: 1px solid #ffe3e3 !important;
        color: #5dc5fa !important;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;
        transition: all 0.2s ease;
      }
      .btn-remove-circle:hover {
        background: #5dc5fa !important;
        color: #ffffff !important;
        border-color: #5dc5fa !important;
      }
      @media (max-width: 575.98px) {
        .wishlist-page-container {
          margin-top: 85px !important;
        }
        .wishlist-header-row {
          margin-bottom: 16px;
        }
        .wishlist-title {
          font-size: 22px;
        }
        .premium-card-wrapper {
          padding: 8px !important;
          border-radius: 16px !important;
        }
        .symmetric-image-frame {
          height: 135px;
          border-radius: 10px !important;
        }
        .mobile-title-size {
          font-size: 13px !important;
        }
        .mobile-price-size {
          font-size: 12px !important;
        }
      }
    `}</style>
  );

  return (
    <>
      {moduleStyles}
      {/* Passing fixedTop={true} forces the attached look immediately on this page */}
      <Navber refreshCart={wishlistLoading} fixedTop={true} />
      <Container className="wishlist-page-container">
        <Row className="wishlist-header-row">
          <Col xs={12}>
            <div className="wishlist-header-wrapper">
              <button onClick={() => navigate(-1)} className="wishlist-back-btn">
                <FiArrowLeft />
                <span>Back</span>
              </button>
              <h3 className="wishlist-title">My Wishlist ❤️</h3>
            </div>
          </Col>
        </Row>

        <Row className="gy-4 justify-content-start">
          {wishlist && wishlist.length > 0 ? (
            wishlist.map((product) => (
              <Col xs={6} sm={6} md={4} lg={3} key={product.item.id}>
                <div className="premium-card-wrapper">
                  <div className="symmetric-image-frame">
                    <img
                      src={product.item.item_photo || logo}
                      alt={product.item.title}
                      className="symmetric-cover-img"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/products/${product.item.id}`)}
                    />
                  </div>

                  <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
                    <h6 className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" style={{ fontSize: "14px" }}>
                      {product.item.title}
                    </h6>

                    <div className="d-flex align-items-center flex-wrap gap-1 gap-sm-2 mb-3">
                      <span className="text-muted text-decoration-line-through mobile-price-size" style={{ fontSize: "13px" }}>
                        ₹{product.item.item_old_price || 0}
                      </span>
                      <span className="fw-bold text-dark mobile-price-size" style={{ fontSize: "14px" }}>
                        ₹{product.item.item_new_price}
                      </span>
                      <span className="fw-bold" style={{ color: '#28a745', fontSize: "12px" }}>
                        {product.item.discount_percentage}% OFF
                      </span>
                    </div>

                    <div className="wishlist-action-container">
                      <button
                        className="btn-orange-pill"
                        onClick={() => navigate(`/products/${product.item.id}`)}
                      >
                        <IoEyeOutline size={16} />
                        <span>Details</span>
                      </button>

                      <button
                        className="btn-remove-circle"
                        onClick={() => !wishlistLoading && toggleWishlist(product.item)}
                        title="Remove"
                      >
                        <IoTrashOutline size={16} />
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <Container className="text-center my-5 py-5">
                <h4 className="fw-bold text-muted">Your wishlist is empty ❤️</h4>
                <button
                  className="btn-orange-pill px-4 mt-3"
                  style={{ maxWidth: "200px", margin: "0 auto" }}
                  onClick={() => navigate("/")}
                >
                  Go Shopping
                </button>
              </Container>
            </Col>
          )}
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default WishlistPage;